module.exports = __webpack_public_path__ + "static/media/goggles-darkmode.b0619040.svg";